/**
 * 微博编辑器路由，只在融合编辑器场景中使用
 */
"use strict";
angular.module("weiboEditPageRouterModule", []).
config(["$stateProvider", function($stateProvider) {
    $stateProvider.state('wbeditpage', {
        url: '/wbeditpage?wbmetadataid&wbchnldocid&wbchannelid&wbplatform',
        views: {
            '': {
                templateUrl: './editingCenter/weibo/editPage/editPage_tpl.html',
                controller: 'weiboEditPageCtrl'
            }
        }
    });
}]);